import { useState } from "react";

export const useFileInput= ()=>{
    const [state, setState] = useState("")
    const handleChange = (e)=>{
        e.preventDefault()
        if (e.target.files[0]) setState(e.target.files[0])
    }

    return [state, handleChange];
}